import script from "./TimelineItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TimelineItem.vue?vue&type=script&setup=true&lang=js"

import "./TimelineItem.vue?vue&type=style&index=0&id=1834d7a1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1834d7a1"]])

export default __exports__